@for (m of matches; track m) {
    <app-match-box [match]="m"></app-match-box>
}

@if (!matches.length) {
    <div class="no-matches">
        <h1>{{ 'HALL_OF_SHAME.NO_MATCHES' | translate }}</h1>
    </div>
}
